export default {"src":"/_next/static/media/contribution2.5df36ecb.svg","height":100,"width":101,"blurWidth":0,"blurHeight":0};